import { useEffect } from 'react';
import { useLocation, type Location } from 'react-router-dom';
import { gtmTrack } from '../utils/gtm';

export const useGtmTrackPageView = (callback: (location: Location) => any) => {
  const location = useLocation();

  useEffect(() => {
    const tagManagerArgs = callback(location);
    gtmTrack(tagManagerArgs);
  }, [location]);

  return null;
};
